import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { TableList, Typography, DropdownMenu, TableListActions } from 'seagull';
import { Edit, EmailSent, UserDelete } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { MemberIdentifyingUnit } from './components/MemberIdentifyingUnit';
import { testPrefix } from './TeamPage.utils';
const statusToColorCode = {
    Active: 'success',
    Pending: 'warning'
};
export default function MemberRow(props) {
    const { t: teamTexts } = useLocaleKeys('pages.teamPage');
    const { data, testId, adminOrMemberActingOnOwner, isEditingTheSoleOwner, isCurrentUser, onChangeRole, onResendInvitation, onRemoveFromTeam } = props;
    const [isResendingInvitation, setIsResendingInvitation] = useState(false);
    const changeRoleOfSoleOwnerTooltip = {
        placement: 'top',
        title: teamTexts.soleOwnerTooltip()
    };
    const roleToLocalizedText = {
        Owner: teamTexts.roles.owner(),
        Admin: teamTexts.roles.admin(),
        Member: teamTexts.roles.member()
    };
    const statusToStatusName = {
        Active: teamTexts.active(),
        Pending: teamTexts.pendingInvitationApproval()
    };
    return /*#__PURE__*/ _jsx(TableList.Row, {
        testId: testId,
        size: "large",
        items: [
            {
                value: /*#__PURE__*/ _jsx(MemberIdentifyingUnit, {
                    user: data.user,
                    testId: "".concat(testPrefix, "-identity")
                })
            },
            {
                value: roleToLocalizedText[data.role],
                testId: "".concat(testPrefix, "-role")
            },
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    skin: statusToColorCode[data.status],
                    testId: "".concat(testPrefix, "-status"),
                    children: statusToStatusName[data.status]
                })
            }
        ],
        actionColumn: /*#__PURE__*/ _jsxs(TableListActions, {
            testId: "".concat(testPrefix, "-actions"),
            children: [
                /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    intent: Intent.ChangeRole,
                    iconStart: /*#__PURE__*/ _jsx(Edit, {
                        size: 18
                    }),
                    testId: "".concat(testPrefix, "-change-role"),
                    disabled: adminOrMemberActingOnOwner || isEditingTheSoleOwner,
                    tooltipProps: isEditingTheSoleOwner ? changeRoleOfSoleOwnerTooltip : undefined,
                    onClick: ()=>onChangeRole(data.user),
                    bi: {
                        name: 'change_role'
                    },
                    children: teamTexts.changeRole()
                }),
                data.user.isInvited() && /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    intent: Intent.ResendMemberInvitation,
                    iconStart: /*#__PURE__*/ _jsx(EmailSent, {
                        size: 18
                    }),
                    testId: "".concat(testPrefix, "-resend-invitation"),
                    disabled: isResendingInvitation,
                    onClick: async ()=>{
                        setIsResendingInvitation(true);
                        await onResendInvitation(data.user);
                        setIsResendingInvitation(false);
                    },
                    bi: {
                        name: 'resend_invitation'
                    },
                    children: teamTexts.resendInvitation()
                }),
                /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    intent: Intent.RemoveFromTeam,
                    skin: "error",
                    iconStart: /*#__PURE__*/ _jsx(UserDelete, {
                        size: 18
                    }),
                    testId: "".concat(testPrefix, "-remove"),
                    disabled: isCurrentUser || adminOrMemberActingOnOwner,
                    onClick: ()=>onRemoveFromTeam(data.user),
                    bi: {
                        name: 'remove_from_team'
                    },
                    children: teamTexts.removeFromTeam()
                })
            ]
        })
    }, data.user.id());
}
